import { render, staticRenderFns } from "./GameBoy.vue?vue&type=template&id=0eda28d4&scoped=true"
import script from "./GameBoy.vue?vue&type=script&lang=js"
export * from "./GameBoy.vue?vue&type=script&lang=js"
import style0 from "./GameBoy.vue?vue&type=style&index=0&id=0eda28d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda28d4",
  null
  
)

export default component.exports